var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.408,
    height: 16.194,
    viewBox: "0 0 24.408 16.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c,.e{fill:none;}.a,.b,.c{stroke:#353841;stroke-width:1.5px;}.b,.c{stroke-linecap:round;}.b{stroke-linejoin:round;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.761)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(14.819 5.844)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 4.795,
    cy: 4.795,
    rx: 4.795,
    ry: 4.795
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 4.795,
    cy: 4.795,
    rx: 4.045,
    ry: 4.045
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 5.844)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 4.795,
    cy: 4.795,
    rx: 4.795,
    ry: 4.795
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 4.795,
    cy: 4.795,
    rx: 4.045,
    ry: 4.045
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6008.573,10171.582l3.315-6.037h6.812l-2.688,5.119s-.283,1.046-2.05,1.008S6008.573,10171.582,6008.573,10171.582Z",
    transform: "translate(-6003.15 -10161.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6013.943,10163.1h-2.39l3.615,6.823",
    transform: "translate(-6004.253 -10161.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6019.977,10160.3h2.332a1.345,1.345,0,0,1,1.5,1.155",
    transform: "translate(-6005.143 -10160.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6020.847,10160.513v4.117l4.318,6.172",
    transform: "translate(-6005.296 -10160.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5747.982,10034.7h-1.92",
    transform: "translate(-5740.234 -10033.542)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.ebca301e95f86c925fca8f914aa1e9ce.svg";
export { ForwardRef as ReactComponent };